import { Pipe, PipeTransform } from '@angular/core';
import { StatusWezwania } from '@interfaces/stypendia/sprawy/sprawy-studentow/wezwania/status-wezwania.enum';

@Pipe({
  name: 'statusWezwaniaStypendia',
})
export class StatusWezwaniaStypendiaPipe implements PipeTransform {
  transform(value: StatusWezwania): string {
    const { Nowe, Zweryfikowano, PrzekazanoDoPodpisu } = StatusWezwania;

    switch (value) {
      case Nowe:
        return 'bg-warning text-secondary';
      case Zweryfikowano:
      case PrzekazanoDoPodpisu:
        return 'bg-success';
      default:
        return 'bg-info';
    }
  }
}
